// @ts-nocheck
import { Card, CircularProgress } from '@material-ui/core';
import BarChartIcon from '@material-ui/icons/InsertChart';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';

export const ENERGY_CARD_BORDER = '#dfe3e8';
export const ENERGY_TEXT_PRIMARY = '#3f3f3f';
export const ENERGY_TEXT_SECONDARY = '#8a8f98';

export const EnergyEmptyCardState = ({ height = 160, entity = 'energyOverviewNoData' }) => (
  <div style={{ height, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
    <BarChartIcon style={{ color: '#bdbdbd', fontSize: 40 }} />
    <h5 style={{ color: '#bdbdbd', fontWeight: 'bold', margin: 0, marginTop: 4 }}><Entity entity={entity} /></h5>
  </div>
);

export const EnergyLoadingCardState = ({ height = 160 }) => (
  <div style={{ height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <CircularProgress size={28} />
  </div>
);

const EnergyOverviewCard = ({ title, children, style, contentStyle }) => (
  <Card
    elevation={3}
    style={{
      borderRadius: 10,
      padding: 15,
      height: '100%',
      boxSizing: 'border-box',
      ...style,
    }}
  >
    {title ? (
      <div style={{ borderBottom: `1px solid ${ENERGY_CARD_BORDER}`, paddingBottom: 10, marginBottom: 14 }}>
        <h4 style={{ margin: 0, fontWeight: 'bold', fontSize: 15, color: ENERGY_TEXT_PRIMARY }}>{title}</h4>
      </div>
    ) : null}
    <div style={contentStyle}>{children}</div>
  </Card>
);

export default EnergyOverviewCard;
